import { Tag } from 'antd';
import * as React from 'react';
import { useRecoilState } from 'recoil';
import { affiliateStateAtom } from 'src/recoils';
import { WithdrawTransferType } from 'src/types';
import colors from 'src/theme/colors.json';

interface ITransferTagProps {
  // When provided (even as null), the tag reflects this row's transfer type
  // instead of the page-wide affiliate mode toggle.
  transferType?: WithdrawTransferType | null;
}

const TransferTag: React.FunctionComponent<ITransferTagProps> = ({ transferType }) => {
  const [affiliateState] = useRecoilState(affiliateStateAtom);
  const isAffiliate = transferType !== undefined
    ? transferType === 'AFFILIATE'
    : affiliateState.isAffiliateMode;
  return <Tag style={{ padding: '6px 16px', fontSize: '14px' }} color={colors['purple-6']}>{isAffiliate ? 'แนะนำเพื่อน' : 'ทั่วไป'}</Tag>;
};

export default TransferTag;
